if (import.meta.env.DEV) {
  const originalError = console.error;
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('Warning: ')) {
      console.warn(...args);
    } else {
      originalError(...args);
    }
  };
}


import React from 'react';
import ReactDOM from 'react-dom/client';
import { components } from './componentMap';
import { AppWrapper } from './app';
import { SemanticToastContainer } from 'react-semantic-toasts-2';

export const getComponent = (componentOrName) => {
  if (typeof componentOrName === 'string') {
    const Component = components[componentOrName];
    if (!Component) {
      console.error(`Component "${componentOrName}" not found.`);
      return null;
    }
    return Component;
  } else if (typeof componentOrName === 'function' || React.isValidElement(componentOrName)) {
    return componentOrName;
  } else {
    console.error('Invalid component or component name provided.');
    return null;
  }
}

export const render = (componentOrName, containerId, props = {}) => {
  const Component = getComponent(componentOrName);
  if (!Component) {
    console.error('Failed to render component: Invalid component or component name provided.');
    return;
  }
  
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container element with id "${containerId}" not found.`);
    return;
  }
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
      <AppWrapper>
        {React.isValidElement(Component) ? Component : <Component {...props} />}
      </AppWrapper>
    </React.StrictMode>
  );
};

export const toastContainer = ()=>{
  const toast = document.createElement("div");
  document.body.appendChild(toast);
  const root = ReactDOM.createRoot(toast);
  root.render(<SemanticToastContainer maxToasts={3} />);
}
